module.exports = __webpack_public_path__ + "img/page-loading.05543df5.gif";